module.exports = __webpack_public_path__ + "img/csr_swiper_02_02.24b0dbe3.jpg";